import { render, staticRenderFns } from "./imageClipping.vue?vue&type=template&id=470a1832&"
import script from "./imageClipping.vue?vue&type=script&lang=ts&"
export * from "./imageClipping.vue?vue&type=script&lang=ts&"
import style0 from "./imageClipping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports